import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { FINANCIAL_SNAPSHOT_API } from './financial-snapshot-api.token';
import { HttpFinancialSnapshotApiService } from './http/http-financial-snapshot-api.service';

/** Registers the live Financial Snapshot API implementation. */
export function provideFinancialSnapshot(): EnvironmentProviders {
  return makeEnvironmentProviders([
    HttpFinancialSnapshotApiService,
    {
      provide: FINANCIAL_SNAPSHOT_API,
      useExisting: HttpFinancialSnapshotApiService,
    },
  ]);
}
